import type { UseCase } from '@/core/shared'
import type { AuthRepository } from '../domain'

export const getUserReportingSettings: UseCase<AuthRepository, 'getUserReportingSettings'> = repository => {
  return async userId => {
    return await repository.getUserReportingSettings(userId)
  }
}
